import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import {
  ApexAxisChartSeries,
  ApexChart,

  ApexDataLabels,

  ApexPlotOptions, ApexXAxis
} from "ng-apexcharts";
import { Color, Label, MultiDataSet } from 'ng2-charts';
import { SalesOrderService } from 'src/app/services/sales-order.service';
import DateUtils from 'src/app/utils/date';

export type ApexChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};

@Component({
  selector: 'app-sales-report',
  templateUrl: './sales-report.component.html',
  styleUrls: ['./sales-report.component.css']
})

export class SalesReportComponent implements OnInit {
  public chartOptions: Partial<ApexChartOptions> = {
    series: [
      {
        name: "basic",
        data: [10, 20, 30, 40, 70]
      }
    ],
    chart: {
      type: "bar",
      height: 270
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: [],
    },
    colors: [
      "rgb(255,177,193))", "rgb(154,208,245)", "rgb(255,230,170)",
      "rgb(165,223,223)", "rgb(204,178,255)"
    ]
  };
  opportunityByReason;
  opportunityByOwner;
  opportunityByCompetitor;
  subscriptionDueChart;
  dashData: { deals: number; dealWon: number; contacts: number; companys: number; leads: number; invoices: number }

  public lineChartData: ChartDataSets[] = [
    { data: [65, 59, 80, 81, 56, 50, 40], label: 'Total Subscription' },
  ];
  public lineChartLabels: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      xAxes: [{}],
      yAxes: [
        {
          id: 'y-axis-0',
          position: 'left',
        },

      ]
    },
    annotation: {
      annotations: [
        {
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: 'March',
          borderColor: 'orange',
          borderWidth: 2,
          label: {
            enabled: true,
            fontColor: 'orange',
            content: 'LineAnno'
          }
        },
      ],
    },
  };
  public lineChartColors: Color[] = [
    { // dark grey
      backgroundColor: 'rgba(204,231,230, 0.5)',
      borderColor: 'rgb(113,132,186)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
  ];
  public lineChartLegend = true;
  public lineChartType: ChartType = 'line';
  // Doughnut
  public doughnutChartLabels: Label[] = ['Twitter', 'Website', 'Facebook', 'Email', 'Deal Source'];
  public doughnutChartData: MultiDataSet = [[350, 450, 100, 150, 120]];
  public doughnutChartType: ChartType = 'doughnut';

  //
  var = {
    startDate: 1593198947918,
    endDate: 1603198947918,
    // startDate: new Date("January 01 2020 00:00:01"),
    // endDate: new Date("December 31 2020 00:00:01"),
  }
  ngChartFilter = [];
  filterByOwners = [];
  filterByCompetitors = [];

  byOwners = [];
  byReasons = [];
  byCompetitors = [];
  dateUtil = new DateUtils();

  loading = {
    byOwners: true,
    byReasons: true,
    byCompetitors: true
  };

  constructor(
    private salesOrderSvc: SalesOrderService,
  ) {
    this.opportunityByReason = {
      series: [
        {
          name: "By Reason",
          data: []
        }
      ],
      xaxis: {
        categories: []
        // categories: ["Odunayo Oseni","Adeyemi Akinyemi","Mary Doe","Peter Shabi","Samuel Ibironke"]
      }
    }
    this.opportunityByOwner = {
      series: [
        {
          name: "By Owner",
          data: []
        }
      ],
      xaxis: {
        categories: []
      }
    }
    this.opportunityByCompetitor = {
      series: [
        {
          name: "By Competitor",
          data: []
        }
      ],
      xaxis: {
        categories: []
      }
    }
    this.subscriptionDueChart = {
      series: [
        {
          name: "Subscription Due",
          data: [10, 20, 15, 30, 25, 40, 70]
        }
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          distributed: true,
          // columnWidth: '30%',
        }
      },
      xaxis: {
        categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July']
      },
      colors: [...this.chartOptions.colors, 'rgb(255,207,159)', 'rgb(204,178,255)']
    }
  }

  async ngOnInit() {
    const { endDate, startDate } = this.dateUtil.getDefaultDateRange();
    this.ngChartFilter = [startDate, endDate];
    // await this.getLostOpportunityByReasonAsync();
    // await this.getLostOpportunityByOwnerAsync();
    // await this.getLostOpportunityByCompetitorAsync();
  }

  private async getDealsStatusStatisticsAsync(filterKey, status) {
    let res;
    const payload = {
      filter: filterKey,
      startDate: this.ngChartFilter[0].getTime(),
      endDate: this.ngChartFilter[1].getTime(),
      status: status,
    };
    res = await this.salesOrderSvc.getDealsStatusStatistics(payload).toPromise();
    return res;
  }

  private async filterByNumber(count: number, arr: any) {
    console.clear()
    let data = arr.reduce((acc, item) => {
    });

  }

  private async getLostOpportunityByReasonAsync() {
    this.loading.byReasons = true;
    // send 0 for open deals, 1 for lost deals and 2 for won deals
    let filter = "REASON", status = 1;
    this.byReasons = await this.getDealsStatusStatisticsAsync(filter, status).then((datas: any[]) => {
      const tableData = [];
      this.opportunityByReason.xaxis.categories = [];
      this.opportunityByReason.series[0].data = [];
      datas.forEach(data => {
        this.opportunityByReason.xaxis.categories.push(data.name);
        this.opportunityByReason.series[0].data.push(data.size);
        this.loading.byReasons = false;
      })
      return datas;
    });
  }

  private async getLostOpportunityByCompetitorAsync() {
    this.loading.byCompetitors = true;
    // send 0 for open deals, 1 for lost deals and 2 for won deals
    let filter = "COMPETITOR", status = 1;
    this.byCompetitors = await this.getDealsStatusStatisticsAsync(filter, status).then((datas: any[]) => {
      const tableData = [];
      this.opportunityByCompetitor.xaxis.categories = [];
      this.opportunityByCompetitor.series[0].data = [];
      if (datas.length > 0) {
        datas.forEach(data => {
          this.opportunityByCompetitor.xaxis.categories.push(data.name);
          this.opportunityByCompetitor.series[0].data.push(data.size);
        });
      }

      this.loading.byCompetitors = false;
      return datas;
    });
  }

  private async getLostOpportunityByOwnerAsync() {
    this.loading.byOwners = true;

    // send 0 for open deals, 1 for lost deals and 2 for won deals
    let filter = "SALESPERSON", status = 1;
    this.byOwners = await this.getDealsStatusStatisticsAsync(filter, status).then((datas: any[]) => {
      const tableData = [];
      this.opportunityByOwner.xaxis.categories = [];
      this.opportunityByOwner.series[0].data = [];

      datas.forEach(data => {
        this.opportunityByOwner.xaxis.categories.push(data.name);
        this.opportunityByOwner.series[0].data.push(data.size);
        this.loading.byOwners = false;
      });

      return datas;
    });
  }

  async filterGraphDataByDate(filterKey) {
    const dateRange = this.ngChartFilter;
    const payload = { filter: filterKey, startDate: dateRange[0], endDate: dateRange[1], status: 1 };
    switch (filterKey) {
      case 'REASON':
        await this.getLostOpportunityByReasonAsync();
        break;

      case 'COMPETITOR':
        await this.getLostOpportunityByCompetitorAsync();
        break;

      case 'SALESPERSON':
        await this.getLostOpportunityByOwnerAsync();
        break;

      default:
        break;
    }
  }

}
